import ApiService from './ApiService';

export default class DashboardApi extends ApiService {
    constructor() {
        super('statistics');
    }

    getStatisticViewForDashboard(payload) {
        return this.get('view', payload);
    }

    getStatisticShopForDashboard(payload) {
        return this.get('shop', payload);
    }
}
